import {IsBoolean, IsEmail, IsOptional, IsString, Matches, MaxLength, MinLength, ValidateIf} from "class-validator";

export class AddContactDto{
  // todo: rename to CreateContactDto
  @IsString()
  @IsEmail()
  @MinLength(5)
  @MaxLength(250)
  @ValidateIf(o=>!!o.email || !!o.phone || !!o.url)
  email?: string;

  @IsString()
  @MinLength(5)
  @MaxLength(50)
  @ValidateIf(o=>!!o.email || !!o.phone || !!o.url)
  phone?: string;

  @IsOptional()
  @IsString()
  @Matches(/^\d{1,20}$/)
  ext?: string;

  @IsOptional()
  @IsBoolean()
  isExtension?: boolean;

  @IsString()
  @MinLength(5)
  @MaxLength(250)
  @ValidateIf(o=>!!o.email || !!o.phone || !!o.url)
  url?: string;
}
